import { render, staticRenderFns } from "./pygame-text.vue?vue&type=template&id=0c7103b2"
import script from "./pygame-text.vue?vue&type=script&lang=js"
export * from "./pygame-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c7103b2')) {
      api.createRecord('0c7103b2', component.options)
    } else {
      api.reload('0c7103b2', component.options)
    }
    module.hot.accept("./pygame-text.vue?vue&type=template&id=0c7103b2", function () {
      api.rerender('0c7103b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/curriculum-manage/components/pygame-text.vue"
export default component.exports